export default __webpack_public_path__ + "static/media/bnr5.c3d81454.jpg";